import type { Environment } from '@shared/environments';
import { createFeatureFlag } from '@shared/featureFlags/featureFlagContextFactory';

export type WebReservationsFeatureFlag =
  | 'testFlag'
  | 'chooseTablesForTiers'
  | 'guestDrivenReservationChanges'
  | 'purchaseEventAddOns'
  | 'newFloorPlanTableFeatures'
  | 'vipProgramCodes'
  | 'newGuestLandingPage'
  | 'hideCancellationAndDressCode'
  | 'redesignedTicketedEventPage';

export const featureFlagConfig: Readonly<
  Record<Environment, Record<WebReservationsFeatureFlag, boolean>>
> = Object.freeze({
  development: {
    testFlag: true,
    chooseTablesForTiers: true,
    guestDrivenReservationChanges: true,
    purchaseEventAddOns: true,
    newFloorPlanTableFeatures: true,
    vipProgramCodes: true,
    newGuestLandingPage: true,
    hideCancellationAndDressCode: true,
    redesignedTicketedEventPage: true,
  },
  ci: {
    testFlag: true,
    chooseTablesForTiers: false,
    guestDrivenReservationChanges: true,
    purchaseEventAddOns: true,
    newFloorPlanTableFeatures: true,
    vipProgramCodes: true,
    newGuestLandingPage: false,
    hideCancellationAndDressCode: false,
    redesignedTicketedEventPage: false,
  },
  staging: {
    testFlag: true,
    chooseTablesForTiers: true,
    guestDrivenReservationChanges: true,
    purchaseEventAddOns: true,
    newFloorPlanTableFeatures: true,
    vipProgramCodes: true,
    newGuestLandingPage: true,
    hideCancellationAndDressCode: true,
    redesignedTicketedEventPage: true,
  },
  demo: {
    testFlag: false,
    chooseTablesForTiers: false,
    guestDrivenReservationChanges: true,
    purchaseEventAddOns: true,
    newFloorPlanTableFeatures: false,
    vipProgramCodes: true,
    newGuestLandingPage: false,
    hideCancellationAndDressCode: true,
    redesignedTicketedEventPage: true,
  },
  production: {
    testFlag: false,
    chooseTablesForTiers: true,
    guestDrivenReservationChanges: true,
    purchaseEventAddOns: true,
    newFloorPlanTableFeatures: true,
    vipProgramCodes: true,
    newGuestLandingPage: true,
    hideCancellationAndDressCode: true,
    redesignedTicketedEventPage: true,
  },
});

export const {
  Provider: FeatureFlagContextProvider,
  useFeatureFlags: useFeatureFlagContext,
  FeatureFlagContext,
} = createFeatureFlag(featureFlagConfig);
